module.exports = __webpack_public_path__ + "static/media/Wispform.ae567937.png";